import { motion } from "framer-motion";
import { Eyebrow, MaskLines } from "@/components/site/Reveal";

const LIST = [
  { n: "Flexible packaging", d: "Laminated pouches, snack and food films." },
  { n: "FIBC & jumbo bags", d: "Food-grade print for bulk material bags." },
  { n: "Cement", d: "Heat resistant print for valve and woven bags." },
  { n: "Fertilizer & agro", d: "Tape tested adhesion on woven PP sacks." },
  { n: "Confectionery", d: "Foil inks for wrappers and food foils." },
  { n: "Poly & carry bags", d: "Everyday print for HM, LDPE and LLDPE." },
];

export const Industries = () => (
  <section data-testid="industries-section" className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
    <Eyebrow>Industries we print for</Eyebrow>
    <h2 className="font-wide mt-6 max-w-4xl text-3xl font-black uppercase leading-[0.95] tracking-tight sm:text-4xl lg:text-6xl">
      <MaskLines onView lines={["Wherever a bag", "needs a brand."]} />
    </h2>
    <div className="mt-16 grid grid-cols-1 border-l border-t border-black/15 sm:grid-cols-2 lg:grid-cols-3">
      {LIST.map((it, i) => (
        <motion.div key={it.n} data-testid={`industry-${i}`}
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: i * 0.06 }}
          className="group relative overflow-hidden border-b border-r border-black/15 p-7 md:p-10">
          <span className="absolute inset-0 translate-y-full bg-[#0B0B0B] transition-transform duration-500 ease-out group-hover:translate-y-0" />
          <div className="relative">
            <span className="font-mono text-xs text-[#FF5A00]">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="font-wide mt-8 text-xl font-bold uppercase tracking-tight transition-colors duration-500 group-hover:text-white md:text-2xl">{it.n}</h3>
            <p className="mt-3 text-sm text-zinc-700 transition-colors duration-500 group-hover:text-zinc-300">{it.d}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
